var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-selector',{staticClass:"grade-selector",attrs:{"items":_vm.items,"grid":_vm.grid,"legend":_vm.legend,"on-item-click":_vm.onGradeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }